import { render, staticRenderFns } from "./HomePostPanelM.vue?vue&type=template&id=5d56febb&lang=pug&"
import script from "./HomePostPanelM.vue?vue&type=script&lang=js&"
export * from "./HomePostPanelM.vue?vue&type=script&lang=js&"
import style0 from "./HomePostPanelM.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports